<div class="dialog-container state-dialog">
  <div class="dialog-body">
    <div *ngIf="!showSentForgotRequest">
      <div class="password-title">{{'FORGOTPASSWORD.TITLE' | translate}}</div>
      <div class="password-box">
        <input [(ngModel)]="phone" [placeholder]="'FORGOTPASSWORD.PHONE' | translate"
               [textMask]="{mask: phoneMask}"
               (input)="phoneChange(phone)">
      </div>
      <div class="confirm-btn">
        <button class="w-btn orange-btn" (click)="forgotPassword(phone)" [disabled]="!validPhone">
          {{'CONFIRM' | translate}}
        </button>
        <button class="w-link-btn" (click)="dialogRef.close()">
          {{'CANCEL' | translate}}
        </button>
      </div>
    </div>
    <div class="forgot-box" *ngIf="showSentForgotRequest">
      <div class="forgot-text">{{'FORGOTPASSWORD.SENTTEXT' | translate}}</div>
      <button class="w-link-btn" (click)="dialogRef.close()">
        {{'CLOSE' | translate}}
      </button>
    </div>
    <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
  </div>
</div>
